import clsx from 'clsx'

interface SidebarSectionProps {
  title: string
  children?: React.ReactNode
  headingChildren?: React.ReactNode
  className?: string
}

export const SidebarSection = ({
  title,
  children,
  headingChildren,
  className,
}: SidebarSectionProps) => {
  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <h3 className="text-xs font-semibold text-dark-muted flex">
        <span>{title}</span>
        {headingChildren}
      </h3>
      {children}
    </div>
  )
}
